// extracted by mini-css-extract-plugin
module.exports = {"form":"SetPassForm_form__3-fg5 form_form__a6yyo","link":"SetPassForm_link__2_tL6 LinkNative_link__hGO0Z"};